import Vue from 'vue';
import Router from 'vue-router';
import HelloWorld from '@/components/HelloWorld';
import Premium from '@/components/Premium';
import Tips from '@/components/Tips';
import Admin from '@/components/Admin';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/marketing/premium',
      name: 'Premium',
      component: Premium,
    },
    {
      path: '/marketing/tips',
      name: 'Tips',
      component: Tips,
    },
    {
      path: '/admin',
      name: 'Admin',
      component: Admin,
    },
    {
      path: '*',
      name: 'HelloWorld',
      component: HelloWorld,
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js